import React, { useContext } from 'react'
import  AccordionContext  from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import cx from 'classnames';
import styles from './styles.module.scss'

function AccordianHeader({eventKey,children,className,onClick}) {
  const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey, () =>{
        if(onClick){
          onClick()
        }}
    );
  return (
    <div onClick={decoratedOnClick} className={styles.AccordianHeader}>
        <i className={cx(styles.headerIcon,className,{
          ['fa-solid fa-minus']: activeEventKey === eventKey,
          ['fa-solid fa-plus']: activeEventKey !==eventKey || !activeEventKey,
        })}></i>
        {children}
    </div>
  )
}

export default AccordianHeader